import { isEmpty } from '@/common/utils/Util';

export default {
  setDetail: (state, data) => {
    state.detail = data;
  },
  setPaymentList: (state, list) => {
    if (isEmpty(state.paymentList)) {
      state.paymentList = list;
    } else {
      state.paymentList = [...state.paymentList, ...list];
    }
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.condition.userNo = '';
    state.paymentList = [];
  }
};
